<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Категория</label>
              <Select2
                :options="categories"
                placeholder="Не выбрано"
                multiple="multiple"
                :settings="{ multiple: true, language: 'ru' }"
                v-model="currFilters.categoryIds"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Критичность</label>
              <Select2
                @keyup.enter="apply"
                :options="severities"
                multiple="multiple"
                placeholder="Не выбрано"
                :settings="{ multiple: true, language: 'ru' }"
                v-model="currFilters.severityIds"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Дата с</label>
              <DateComponent
                @keyupEnter="apply"
                v-model="currFilters.dateFrom"
              ></DateComponent>
              <label>по</label>
              <DateComponent
                @keyupEnter="apply"
                v-model="currFilters.dateTo"
              ></DateComponent>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Пользователь</label>
              <Select2
                @keyup.enter="apply"
                :options="users"
                placeholder="Не выбрано"
                multiple="multiple"
                :settings="{ multiple: true, language: 'ru' }"
                v-model="currFilters.userIds"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Событие</label>
              <Select2
                @keyup.enter="apply"
                :options="permissions"
                multiple="multiple"
                placeholder="Не выбрано"
                :settings="{ multiple: true, language: 'ru' }"
                v-model="currFilters.permissionIds"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Тип объекта</label>
              <Select2
                @keyup.enter="apply"
                :options="entityTypes"
                multiple="multiple"
                :settings="{ multiple: true, language: 'ru' }"
                placeholder="Не выбрано"
                v-model="currFilters.entityTypeIds"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Справочник</label>
              <Select2
                @keyup.enter="apply"
                :options="dictionaries"
                multiple="multiple"
                placeholder="Не выбрано"
                :settings="{ multiple: true, language: 'ru' }"
                v-model="currFilters.dictionaryIds"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-between">
        <button-component class="col-6" @click="apply"
          >Применить</button-component
        >
        <button-component class="col-6" kind="secondary" @click="reset"
          >Сбросить</button-component
        >
      </div>
    </div>
  </div>
</template>

<script>
import API from "../api/log";
import UserAPI from "../api/users";
import RoleAPI from "../api/roles";
import DateComponent from "../../../common/components/DateComponent";
import ButtonComponent from "@/common/ui/ButtonComponent";

export default {
  name: "LogFilter",
  components: { ButtonComponent, DateComponent },
  props: {
    filters: Object,
  },
  data() {
    return {
      currFilters: this.filters,
      categories: [],
      severities: [],
      users: [],
      permissions: [],
      entityTypes: [],
      dictionaries: [],
    };
  },
  created() {
    this.loadDictionaries();
  },
  methods: {
    loadDictionaries() {
      API.getCategories().then((response) => {
        this.categories = response.data.map((x) => ({
          id: x.id,
          text: x.title,
        }));
      });
      API.getSeverities().then((response) => {
        this.severities = response.data.map((x) => ({
          id: x.id,
          text: x.title,
        }));
      });
      UserAPI.search({ pageNumber: 1, pageSize: -1 }).then((response) => {
        this.users = response.data.items.map((x) => ({
          id: x.id,
          text: `${x.fullName} (${x.userName})`,
        }));
      });
      RoleAPI.loadPermissions().then((response) => {
        this.permissions = response.data.items.map((x) => ({
          id: x.id,
          text: x.name,
        }));
      });
      API.getEntityTypes().then((response) => {
        this.entityTypes = response.data.map((x) => ({
          id: x.id,
          text: x.title,
        }));
      });
      API.getDictionaries().then((response) => {
        this.dictionaries = response.data.map((x) => ({
          id: x.id,
          text: x.title,
        }));
      });
    },
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        categoryIds: [],
        severityIds: [],
        dateFrom: null,
        dateTo: null,
        userIds: [],
        permissionIds: [],
        entityTypeIds: [],
        dictionaryIds: [],
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/theme/default/colors";

.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}
.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
